import {
    BulkActionScenarioType,
    BulkActionInformation,
    BulkActionStateEnum,
} from 'owa-bulk-action-store';
import folderStore, { getEffectiveFolderDisplayName } from 'owa-folders';
import { RuleBulkActionCustomData } from 'owa-inbox-rules-option';
import loc, { format } from 'owa-localize';
import { SweepBulkActionCustomData } from 'owa-mail-sweep-store';
import {
    bulkAction_emptyFolderSuccess,
    bulkAction_moveFromToSuccess,
    bulkAction_runRuleSuccess,
    emptyFolderFailStatus,
    bulkAction_moveFromToFail,
    bulkAction_runRuleNowFail,
    bulkAction_canceled,
    bulkAction_canceling,
    bulkAction_NofM,
    bulkAction_emptyingFolder,
    bulkAction_movingFromTo,
    bulkAction_runningRule,
    bulkAction_genericStatus,
} from './getBulkActionStatusText.locstring.json';

export default function getBulkActionStatusText(
    bulkActionInfo: BulkActionInformation,
    scenario: BulkActionScenarioType,
    customData: any
): string {
    switch (bulkActionInfo.state) {
        case BulkActionStateEnum.Complete:
            switch (scenario) {
                case 'EmptyFolder':
                    return loc(bulkAction_emptyFolderSuccess);
                case 'Sweep':
                    const sweepCustomData: SweepBulkActionCustomData = customData;
                    const destinationFolder = folderStore.folderTable.get(
                        sweepCustomData.destinationFolderId
                    );

                    return format(
                        loc(bulkAction_moveFromToSuccess),
                        sweepCustomData.senderSMTPs,
                        getEffectiveFolderDisplayName(destinationFolder)
                    );
                case 'RunRuleNow':
                    const ruleCustomData: RuleBulkActionCustomData = customData;

                    return format(loc(bulkAction_runRuleSuccess), ruleCustomData.ruleName);
            }
            break;
        case BulkActionStateEnum.Failed:
        case BulkActionStateEnum.Timeout:
            const unprocessed =
                bulkActionInfo.progress.totalCount - bulkActionInfo.progress.processedCount;
            switch (scenario) {
                case 'EmptyFolder':
                    return format(loc(emptyFolderFailStatus), unprocessed);
                case 'Sweep':
                    return format(loc(bulkAction_moveFromToFail), unprocessed);
                case 'RunRuleNow':
                    return format(loc(bulkAction_runRuleNowFail), unprocessed);
            }
            break;
        case BulkActionStateEnum.Cancelled:
            return loc(bulkAction_canceled);
        case BulkActionStateEnum.Cancelling:
            return loc(bulkAction_canceling);
        case BulkActionStateEnum.Uninitialized:
        case BulkActionStateEnum.Running:
            const progress = format(
                loc(bulkAction_NofM),
                bulkActionInfo.progress.processedCount,
                bulkActionInfo.progress.totalCount
            );
            switch (scenario) {
                case 'EmptyFolder':
                    return `${loc(bulkAction_emptyingFolder)} ${progress}`;
                case 'Sweep':
                    const sweepCustomData: SweepBulkActionCustomData = customData;
                    const destinationFolder = folderStore.folderTable.get(
                        sweepCustomData.destinationFolderId
                    );
                    return format(
                        loc(bulkAction_movingFromTo),
                        sweepCustomData.senderSMTPs,
                        getEffectiveFolderDisplayName(destinationFolder)
                    );
                case 'RunRuleNow':
                    const ruleCustomData: RuleBulkActionCustomData = customData;
                    return format(loc(bulkAction_runningRule), ruleCustomData.ruleName);
                default:
                    throw new Error('Invalid bulk action scenario type');
            }
    }
    return loc(bulkAction_genericStatus); // If we don't know bulk action class, just make it generic text by default
}
